<template>
    <div>
      <el-form-item label="内容">
        <el-checkbox border v-model="config.pinyin" label="有拼音"></el-checkbox>
        <el-checkbox border v-model="config.image" label="有图片"></el-checkbox>
      </el-form-item>
      <el-form-item label="角色">
        <el-radio-group v-model="config.role">
          <el-radio-button :label="0">默认(后台分配)</el-radio-button>
          <el-radio-button :label="1">用户选择</el-radio-button>
          <el-radio-button :label="2">自动分配</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="显示类型">
        <el-radio-group v-model="config.showType">
          <el-radio-button :label="0">默认</el-radio-button>
          <el-radio-button :label="1">仅显示文案</el-radio-button>
          <el-radio-button :label="2">仅播放音频</el-radio-button>
          <el-radio-button :label="3">显示文案和播放音频</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="允许重读">
        <el-radio-group v-model="config.reread">
          <el-radio-button :label="true">允许</el-radio-button>
          <el-radio-button :label="false">不允许</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="重读条件" v-show="config.reread">
        <el-input-number v-model="config.rereadScore" :min="0" title="允许重读的分数, 低于此值才允许重读"></el-input-number>
      </el-form-item>
      <el-form-item label="答题解析">
        <el-checkbox border v-model="config.showReviewsContent" label="内容说明"></el-checkbox>
        <el-checkbox border v-model="config.showReviewsGrammar" label="关联语法"></el-checkbox>
      </el-form-item>
      <el-form-item label="AI超解析">
        <el-radio-group v-model="config.aiChao">
          <el-radio-button :label="0">没有小超</el-radio-button>
          <el-radio-button :label="1">有小超没有解析</el-radio-button>
          <el-radio-button :label="2">有小超有解析</el-radio-button>
        </el-radio-group>
      </el-form-item>
    </div>
</template>

<script>
export default {
  name: 'dht',
  data () {
    return {
      config: {
        pinyin: true,
        image: false,
        role: 0,
        reread: false,
        rereadScore: 0,
        showType: 0,
        showReviewsContent: false,
        showReviewsGrammar: false,
        aiChao: 0,
      }
    }
  }
}
</script>